let buf: Uint8Array,
  bufIdx = 0

const hexBytes: string[] = Array.from(Array(256), (_, k) => (k + 0x100).toString(16).slice(1))
const MAX_BUFF_SIZE = 4096

/**
 * uuid v4实现
 * @returns xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 * @remark x为[0-9, a-f]，M为4，N为[8, 9, a, b]
 */
export function uuid() {
  if (buf === void 0 || bufIdx + 16 > MAX_BUFF_SIZE) {
    buf = crypto.getRandomValues(new Uint8Array(MAX_BUFF_SIZE))
  }

  const useBuf = buf.slice(bufIdx, (bufIdx += 16))

  useBuf[6] = (useBuf[6] & 0x0f) | 0x40
  useBuf[8] = (useBuf[8] & 0x3f) | 0x80

  const res: string[] = []

  for (let i = 0; i < 16; i++) {
    res.push(hexBytes[useBuf[i]])
    if (i === 3 || i === 5 || i === 7 || i === 9) {
      res.push('-')
    }
  }

  return res.join('')
}

/**
 * uuid v4实现，简洁版
 * @returns
 */
export default function uuidv4(): string {
  return (([1e7] as any) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
  )
}
